<template>
  <div class="addCar">
    <van-popup
      v-model="show"
      round
      :style="{ width: '80vw' }"
    >
      <div class="header">
        请将行驶证正本置于摄像头中央
      </div>
      <div class="content">
        <img src="@/assets/img/ticket/pic_photo.png" class="img" alt="">
      </div>
      <div class="info">请将您的证件摆放端正，保证信息清晰，四角齐全，表面无反光</div>
      <div class="btn">
        <van-uploader accept="image/*" :after-read="afterRead">
          <van-button type="info" size="large">立即上传</van-button>
        </van-uploader>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "",
  components: {
  },
  props: {
    showOcr: {
      type: Boolean
    }
  },
  data() {
    return {
      show: false
    }
  },
  watch: {
    showOcr(val) {
      this.show = val
    }
  },
  methods: {
    cancel() {
      this.show =  false
      this.$emit('cancel')
    },
    async afterRead(data) {
      this.show =  false
      this.$emit('afterRead', data)
    }
  }
}
</script>
<style scoped lang="scss">
.addCar{
  .header{
    height: 1.3rem;
    line-height: 1.3rem;
    color: #383838;
    font-size: 0.32rem;
    text-align: center;
    font-weight: 700;
  }
  .content{
    display: flex;
    justify-content: center;
    .img{
      width: 70vw;
    }
  }
  .info{
    text-align: center;
    color: #646464;
    font-size: 0.28rem;
    padding: 0.2rem 0.3rem;
    box-sizing: border-box;
  }
  .btn{
    padding: 0 0.3rem 0.5rem;
    box-sizing: border-box;
  }
  /deep/ .van-button--large{
    border-radius: 0.8rem;
  }
  /deep/ .van-uploader__input-wrapper{
    width: 70vw;
  }
}
</style>